<template>
  <div class="system-qr-page">
    <vx-card class="mb-6">
      <form class="qr-filters mb-4" @submit.prevent="search">
        <label
          >ชื่อสัญญา<input
            v-model="filters.contractName"
            maxlength="120"
            :disabled="busy"
            @input="scheduleSearch"
            @compositionstart="scheduleSearch({ isComposing: true })"
            @compositionend="scheduleSearch"
            placeholder="ค้นหาบางส่วนของชื่อสัญญา"
        /></label>
        <label
          >เลขที่สัญญา<input
            v-model="filters.contractNo"
            maxlength="120"
            :disabled="busy"
            @input="scheduleSearch"
            @compositionstart="scheduleSearch({ isComposing: true })"
            @compositionend="scheduleSearch"
            placeholder="ค้นหาบางส่วนของเลขที่สัญญา"
        /></label>
        <label
          >ประเภท<select
            v-model="filters.type"
            :disabled="busy"
            @change="search"
          >
            <option value="">ทั้งหมด</option>
            <option v-for="type in qrTypes" :key="type" :value="type">
              {{ qrTypeName(type) }}
            </option>
          </select></label
        >
        <label
          >สถานะ<select
            v-model="filters.paymentStatus"
            :disabled="busy"
            @change="search"
          >
            <option value="UNPAID">ยังไม่ชำระ</option>
            <option value="PAID">มีรายการรับชำระ</option>
            <option value="CANCELLED">ยกเลิก/ปิดใช้งาน</option>
            <option value="ALL">ทั้งหมด</option>
          </select></label
        >
        <label
          >เรียงลำดับ<select
            v-model="filters.sort"
            :disabled="busy"
            @change="search"
          >
            <option value="CREATED_AT_DESC">
              วันที่สร้าง: ใหม่ก่อน (createdAt desc)
            </option>
            <option value="CREATED_AT_ASC">
              วันที่สร้าง: เก่าก่อน (createdAt asc)
            </option>
            <option value="SUCCESS_AT_DESC">
              วันที่ชำระ: ใหม่ก่อน (successAt desc)
            </option>
            <option value="SUCCESS_AT_ASC">
              วันที่ชำระ: เก่าก่อน (successAt asc)
            </option>
          </select></label
        >
        <button type="button" :disabled="busy" @click="clearFilters">
          ล้างตัวกรอง
        </button>
      </form>
    </vx-card>
    <vx-card title="ตรวจสอบคิวอาร์โค้ด">
      <div class="qr-toolbar">
        <span aria-live="polite">{{
          loading || debouncePending
            ? "กำลังค้นหา…"
            : "ทั้งหมด " + total + " รายการ"
        }}</span
        ><input
          v-model="filters.search"
          maxlength="120"
          :disabled="busy"
          aria-label="ค้นหา QR"
          placeholder="ค้นหาเลขสัญญา ชื่อสัญญา หรือ Ref"
          @input="scheduleSearch"
          @compositionstart="scheduleSearch({ isComposing: true })"
          @compositionend="scheduleSearch"
        />
      </div>
      <p v-if="!testEnabled && !loading" class="mb-4">
        ปุ่มทดสอบปิดอยู่ กรุณาตรวจ config dev และสิทธิ์แก้ไขของผู้ดูแลระบบ
      </p>
      <p v-if="error" role="alert" class="text-danger mb-4">{{ error }}</p>
      <div class="qr-table-wrap">
        <table class="qr-table">
          <thead>
            <tr>
              <th>สร้างเมื่อ (เวลาไทย)</th>
              <th>ชำระเมื่อ (เวลาไทย)</th>
              <th>ชื่อสัญญา</th>
              <th>สัญญา / Ref 1</th>
              <th>Ref 2</th>
              <th>ประเภท</th>
              <th>ยอด (บาท)</th>
              <th>สถานะ</th>
              <th>ดำเนินการ</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="qr in items" :key="qr.id">
              <td>{{ dateTime(qr.createdAt) }}</td>
              <td>{{ qr.successAt ? dateTime(qr.successAt) : "—" }}</td>
              <td>
                {{
                  qr.loan && qr.loan.contract
                    ? qr.loan.contract.contractName || "—"
                    : "—"
                }}
              </td>
              <td>{{ qr.ref1 }}</td>
              <td>{{ qr.ref2 }}</td>
              <td>{{ qrTypeName(qr.type) }}</td>
              <td>{{ money(qr.amount) }}</td>
              <td>{{ qrStatus(qr) }}</td>
              <td class="qr-actions">
                <vs-button
                  size="small"
                  :disabled="busy || loading"
                  @click="showQr(qr)"
                  >แสดง QR</vs-button
                >
                <vs-button
                  v-if="isRoot"
                  size="small"
                  color="danger"
                  type="border"
                  :disabled="
                    busy ||
                    loading ||
                    debouncePending ||
                    mustRefresh ||
                    !canCancel(qr)
                  "
                  @click="askCancel(qr)"
                  >ยกเลิก QR</vs-button
                >
                <vs-button
                  v-for="action in actions"
                  :key="action.value"
                  size="small"
                  type="border"
                  :disabled="
                    !testEnabled ||
                    busy ||
                    loading ||
                    mustRefresh ||
                    debouncePending ||
                    !canTestQr(qr)
                  "
                  @click="ask(qr, action.value)"
                  >{{ action.label }}</vs-button
                >
              </td>
            </tr>
            <tr v-if="!items.length">
              <td colspan="9">
                {{ loading ? "กำลังโหลด…" : "ไม่พบ QR Code" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="qr-pagination">
        <label class="qr-page-size"
          >รายการต่อหน้า:
          <select
            :value="pageSize"
            :disabled="loading || busy || debouncePending"
            @change="changeSize($event.target.value)"
            aria-label="รายการต่อหน้า"
          >
            <option
              v-for="size in [5, 10, 20, 25, 50, 100]"
              :key="size"
              :value="size"
            >
              {{ size }}
            </option>
          </select>
        </label>
        <span
          >{{ items.length ? (page - 1) * pageSize + 1 : 0 }}-{{
            items.length ? (page - 1) * pageSize + items.length : 0
          }}
          จาก {{ total }}</span
        >
        <nav class="qr-page-buttons" aria-label="การแบ่งหน้า QR">
          <button
            v-for="control in pageControls"
            :key="control.label"
            type="button"
            :title="control.label"
            :aria-label="control.label"
            :disabled="
              loading ||
              busy ||
              debouncePending ||
              !!error ||
              (control.back ? page <= 1 : page >= lastPage)
            "
            @click="refresh(control.target)"
          >
            <svg aria-hidden="true" viewBox="0 0 24 24">
              <path :d="control.path" />
            </svg>
          </button>
        </nav>
      </div>
      <vs-popup
        :title="actionError ? 'ยังยืนยันผลไม่ได้' : 'ผลการดำเนินการ'"
        :active.sync="resultOpen"
      >
        <p v-if="actionError" role="alert" class="text-danger mb-4">
          {{ actionError }}
        </p>
        <div
          v-if="result && !actionError"
          role="status"
          class="qr-action-result"
          :class="
            result.responseCode === '000'
              ? 'qr-action-success'
              : 'qr-action-warning'
          "
        >
          <p>
            <strong
              >{{ result.action }} · {{ result.responseCode }}:
              {{ result.responseMesg }}</strong
            >
          </p>
          <p>Request: {{ result.requestRef }}</p>
          <p v-if="result.warning">{{ result.warning }}</p>
          <p v-if="result.action === 'NOTIFY'">
            ตรวจสอบรายการรับชำระในสัญญาเพื่อยืนยันผลการประมวลผลด้วย
          </p>
        </div>
        <vs-button class="mt-4" @click="resultOpen = false">ตกลง</vs-button>
      </vs-popup>
      <QrPaymentModal :active.sync="qrOpen" :qr="selected" />
      <vs-popup
        :title="
          pending && pending.action === 'CANCEL'
            ? 'ยืนยันยกเลิก QR Code'
            : 'ยืนยันการทดสอบ dev'
        "
        :active.sync="confirmOpen"
      >
        <div v-if="pending">
          <p>
            {{ pending.action }} · สัญญา {{ pending.qr.ref1 }} ·
            {{ money(pending.qr.amount) }} บาท
          </p>
          <p class="my-4">{{ actionDescription(pending.action) }}</p>
          <vs-button :disabled="busy || mustRefresh" @click="send()">{{
            busy ? "กำลังส่ง…" : "ยืนยันส่งคำสั่ง"
          }}</vs-button>
          <vs-button
            type="border"
            class="ml-2"
            :disabled="busy"
            @click="confirmOpen = false"
            >ยกเลิก</vs-button
          >
        </div>
      </vs-popup>
    </vx-card>
  </div>
</template>
<script>
import { gql } from "apollo-boost";
import { apolloClient } from "@/setup/apollo-setup";
import { IStatus, IQrPaymentType } from "@/constants/interface";
import QrPaymentModal from "@/components/QrPaymentModal.vue";
const LIST = gql`
  query SystemQrPayments(
    $page: Int
    $pageSize: Int
    $contractNo: String
    $contractName: String
    $search: String
    $type: String
    $paymentStatus: SystemQrPaymentStatus
    $sort: SystemQrPaymentSort
  ) {
    getSystemQrPayments(
      page: $page
      pageSize: $pageSize
      contractNo: $contractNo
      contractName: $contractName
      search: $search
      type: $type
      paymentStatus: $paymentStatus
      sort: $sort
    ) {
      day
      total
      page
      pageSize
      testEnabled
      items {
        loan {
          contract {
            contractName
          }
        }
        id
        type
        taxId
        suffix
        ref1
        ref2
        amount
        createdAt
        status
        success
        successAt
        payment {
          id
        }
        paymentExpense {
          id
        }
        paidFee
        paidPenalty
        paidInterest
        paidPrinciple
        balanceRemain
        paidContractFee
        paidTaxAmount
        paidProcessingFee
        paidCourtOrderExpense
        dueDate(local: true, format: "DD MMM YYYY HH:mm น.")
      }
    }
  }
`;
const TEST = gql`
  mutation TestDevQrPayment($qrPaymentId: ID!, $action: DevQrAction!) {
    testDevQrPayment(qrPaymentId: $qrPaymentId, action: $action) {
      action
      requestRef
      responseCode
      responseMesg
      warning
    }
  }
`;
const CANCEL = gql`
  mutation CancelUnpaidQrPayment($qrPaymentId: ID!) {
    cancelUnpaidQrPayment(qrPaymentId: $qrPaymentId)
  }
`;
const defaultFilters = () => ({
  contractNo: "",
  contractName: "",
  search: "",
  type: "",
  paymentStatus: "UNPAID",
  sort: "CREATED_AT_DESC",
});
export default {
  components: { QrPaymentModal },
  data() {
    return {
      filters: defaultFilters(),
      appliedFilters: defaultFilters(),
      requestId: 0,
      searchTimer: null,
      debouncePending: false,
      disposed: false,
      items: [],
      total: 0,
      page: 1,
      pageSize: 25,
      day: "",
      testEnabled: false,
      loading: false,
      busy: false,
      error: "",
      actionError: "",
      resultOpen: false,
      result: null,
      mustRefresh: false,
      selected: null,
      qrOpen: false,
      confirmOpen: false,
      pending: null,
      actions: [
        { value: "VERIFY", label: "Verify" },
        { value: "NOTIFY", label: "Noti" },
        { value: "REVERSE", label: "Revert" },
      ],
    };
  },
  computed: {
    qrTypes() {
      return Object.values(IQrPaymentType);
    },
    lastPage() {
      return Math.max(1, Math.ceil(this.total / this.pageSize));
    },
    pageControls() {
      return [
        {
          label: "หน้าแรก",
          target: 1,
          back: true,
          path: "M5 5v14 M19 5L8 12l11 7Z",
        },
        {
          label: "หน้าก่อนหน้า",
          target: this.page - 1,
          back: true,
          path: "m15 6-6 6 6 6",
        },
        {
          label: "หน้าถัดไป",
          target: this.page + 1,
          back: false,
          path: "m9 6 6 6-6 6",
        },
        {
          label: "หน้าสุดท้าย",
          target: this.lastPage,
          back: false,
          path: "M19 5v14 M5 5l11 7-11 7Z",
        },
      ];
    },
  },
  beforeDestroy() {
    this.disposed = true;
    this.requestId++;
    clearTimeout(this.searchTimer);
  },
  created() {
    if (
      this.isRoot ||
      this.pms("SystemQrPayments", "visible", "b") ||
      this.pms("SystemAdministrator", "visible", "r")
    )
      this.refresh();
  },
  methods: {
    scheduleSearch(event = {}) {
      if (this.busy) return;
      clearTimeout(this.searchTimer);
      this.requestId++;
      this.debouncePending = true;
      if (!event.isComposing)
        this.searchTimer = setTimeout(() => this.search(), 400);
    },
    changeSize(value) {
      this.pageSize = Number(value);
      return this.refresh(1);
    },
    canCancel(qr) {
      return (
        qr.status === IStatus.enabled &&
        qr.success === false &&
        !qr.successAt &&
        !qr.payment &&
        !qr.paymentExpense
      );
    },
    canTestQr(qr) {
      if (!this.canCancel(qr) || this.unsupported(qr) || !this.day)
        return false;
      const end = new Date(this.day + "T00:00:00+07:00").getTime() + 86400000;
      const created = new Date(qr.createdAt).getTime();
      return created >= end - 7 * 86400000 && created < end;
    },
    qrStatus(qr) {
      return qr.success || qr.successAt || qr.payment || qr.paymentExpense
        ? "มีรายการรับชำระ"
        : qr.status !== IStatus.enabled
        ? "ยกเลิก/ปิดใช้งาน"
        : "ยังไม่ชำระ";
    },

    search() {
      if (this.busy) return;
      clearTimeout(this.searchTimer);
      this.debouncePending = false;
      this.appliedFilters = {
        contractNo: this.filters.contractNo.trim(),
        contractName: this.filters.contractName.trim(),
        search: (this.filters.search || "").trim(),
        type: this.filters.type || "",
        paymentStatus: this.filters.paymentStatus || "UNPAID",
        sort: this.filters.sort || "CREATED_AT_DESC",
      };
      return this.refresh(1);
    },
    clearFilters() {
      if (this.busy) return;
      this.filters = defaultFilters();
      return this.search();
    },
    actionErrorMessage(error) {
      const messages =
        error && Array.isArray(error.graphQLErrors)
          ? error.graphQLErrors.map((item) => item.message).filter(Boolean)
          : [];
      const message =
        [...new Set(messages)].join(" / ") ||
        (error && error.message) ||
        "ยังยืนยันผลจาก noti server ไม่ได้";
      const clean = message.replace(/^(GraphQL error:\s*)+/i, "");
      return clean.includes("ตรวจรายการรับชำระ")
        ? clean
        : clean + " — รีเฟรชหน้าเว็บและตรวจรายการรับชำระก่อนส่งซ้ำ";
    },
    qrTypeName(type) {
      const names = {
        extra: "ชำระเพิ่มเติม",
        normal: "ยอดปัจจุบัน",
        custom: "กำหนดยอดเอง",
        close: "ยอดปิดบัญชี",
        outstanding: "ยอดค้างชำระ",
        contractFee: "ค่าธรรมเนียมการทำสัญญา",
        registrationFeeExtra: "ค่าลงทะเบียน",
        taxAmount: "ค่าอากรแสตมป์",
        processingFee: "ค่าดำเนินการ",
        courtOrderExpense: "ค่าใช้จ่ายอื่นตามคำสั่งศาล",
        allExpenses: "ค่าใช้จ่ายทั้งหมด",
      };
      return Object.prototype.hasOwnProperty.call(names, type)
        ? names[type]
        : type || "ไม่ระบุประเภท";
    },
    money(value) {
      return Number(value).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    dateTime(value) {
      return new Date(value).toLocaleString("th-TH", {
        timeZone: "Asia/Bangkok",
        hour12: false,
      });
    },
    unsupported(qr) {
      return ["extra", "registrationFeeExtra"].includes(qr.type);
    },
    async refresh(page = this.page) {
      const requestId = ++this.requestId;
      this.loading = true;
      this.error = "";
      this.testEnabled = false;
      try {
        const { data } = await apolloClient.query({
          query: LIST,
          variables: { page, pageSize: this.pageSize, ...this.appliedFilters },
          fetchPolicy: "network-only",
        });
        if (this.disposed || requestId !== this.requestId) return;
        Object.assign(this, data.getSystemQrPayments);
        this.mustRefresh = false;
        this.pending = null;
        this.confirmOpen = false;
      } catch (error) {
        if (this.disposed || requestId !== this.requestId) return;
        this.items = [];
        this.total = 0;
        this.error = error.message || "โหลดข้อมูลไม่สำเร็จ";
        this.mustRefresh = true;
      } finally {
        if (!this.disposed && requestId === this.requestId)
          this.loading = false;
      }
    },
    showQr(qr) {
      this.selected = { ...qr };
      this.qrOpen = true;
    },
    actionDescription(action) {
      if (action === "CANCEL")
        return "ยกเลิก QR ที่ยังไม่รับชำระเท่านั้น QR นี้จะใช้ชำระไม่ได้อีก เก็บประวัติไว้และไม่ใช่การคืนเงินผ่านธนาคาร";
      return action === "NOTIFY"
        ? "จำลองรับเงิน: จะบันทึกการชำระและประมวลผลยอดในฐานข้อมูล dev จริง"
        : action === "REVERSE"
        ? "เรียก reverse: ปัจจุบัน noti server ตอบรับเท่านั้น ยังไม่มีการย้อนรายการชำระ"
        : "ตรวจสอบข้อมูล QR ผ่าน noti server และบันทึก verify log ใน dev";
    },
    ask(qr, action) {
      if (
        !this.testEnabled ||
        this.busy ||
        this.loading ||
        this.mustRefresh ||
        this.debouncePending ||
        !this.canTestQr(qr)
      )
        return;
      this.pending = { qr, action };
      this.confirmOpen = true;
    },
    askCancel(qr) {
      if (
        !this.isRoot ||
        this.busy ||
        this.loading ||
        this.mustRefresh ||
        this.debouncePending ||
        !this.canCancel(qr)
      )
        return;
      this.pending = { qr, action: "CANCEL" };
      this.confirmOpen = true;
    },
    async send() {
      if (
        !this.pending ||
        this.busy ||
        this.loading ||
        this.debouncePending ||
        this.mustRefresh
      )
        return;
      if (this.pending.action === "CANCEL" ? !this.isRoot : !this.testEnabled)
        return;
      this.busy = true;
      this.error = "";
      this.result = null;
      this.actionError = "";
      this.resultOpen = false;
      const pending = this.pending;
      try {
        if (pending.action === "CANCEL") {
          await apolloClient.mutate({
            mutation: CANCEL,
            variables: { qrPaymentId: pending.qr.id },
          });
          this.result = {
            action: "ยกเลิก QR",
            responseCode: "000",
            responseMesg: "ยกเลิก QR Code เรียบร้อยแล้ว",
            requestRef: pending.qr.ref2,
          };
        } else {
          const { data } = await apolloClient.mutate({
            mutation: TEST,
            variables: { qrPaymentId: pending.qr.id, action: pending.action },
          });
          this.result = data.testDevQrPayment;
        }
        this.confirmOpen = false;
        this.qrOpen = false;
        await this.refresh();
        this.resultOpen = true;
      } catch (error) {
        this.actionError = this.actionErrorMessage(error);
        this.resultOpen = true;
        this.mustRefresh = true;
        this.confirmOpen = false;
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
<style scoped>
.qr-action-result {
  padding: 16px;
  border-radius: 6px;
  line-height: 1.7;
  overflow-wrap: anywhere;
}
.qr-action-success {
  background: #eaf7ef;
  color: #176534;
}
.qr-action-warning {
  background: #fff4df;
  color: #805600;
}
.qr-table-wrap {
  overflow-x: auto;
}
.qr-table {
  width: 100%;
  border-collapse: collapse;
}
.qr-table th,
.qr-table td {
  padding: 12px;
  border-bottom: 1px solid #ddd;
  text-align: left;
  white-space: nowrap;
}
.qr-actions > * {
  margin: 3px;
}
.qr-pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 24px;
  align-items: center;
  padding-top: 24px;
  margin-top: 24px;
  border-top: 1px solid #ebe9ee;
  color: #777383;
  font-size: 16px;
}
.qr-page-size,
.qr-page-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
}
.qr-page-size select {
  width: 110px;
  height: 42px;
  padding: 8px 20px;
  border: 1px solid #d8d6de;
  border-radius: 8px;
  background: white;
  color: inherit;
  font: inherit;
}
.qr-page-buttons button {
  width: 40px;
  height: 40px;
  padding: 8px;
  border: 0;
  border-radius: 50%;
  color: #8c8797;
  background: transparent;
  cursor: pointer;
}
.qr-page-buttons button:disabled {
  opacity: 0.5;
  cursor: default;
}
.qr-page-buttons button:not(:disabled):hover {
  background: #f4f2ff;
}
.qr-page-buttons svg {
  width: 24px;
  height: 24px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.qr-toolbar {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}
.qr-toolbar input {
  width: 360px;
  max-width: 100%;
  padding: 10px 12px;
  border: 1px solid #d8d6de;
  border-radius: 6px;
}
.qr-filters button {
  margin-left: auto;
}
.qr-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}
.qr-filters label {
  flex: 1 1 220px;
}
.qr-filters input,
.qr-filters select {
  display: block;
  width: 100%;
  padding: 9px 12px;
  margin-top: 5px;
  border: 1px solid #d5dce3;
  border-radius: 5px;
}
.qr-filters button {
  padding: 9px 16px;
  border: 1px solid #174e78;
  border-radius: 5px;
  color: #174e78;
  background: white;
  cursor: pointer;
}
.qr-filters button[type="submit"] {
  background: #174e78;
  color: white;
}
.qr-filters button:disabled {
  opacity: 0.5;
  cursor: default;
}
</style>
